import RadioInput from 'components/atoms/form/RadioInput/RadioInput'
import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { FaInfoCircle } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import OtaRateProgramsService from 'services/OtaRateProgramsService'
import {
    isArrayNotEmpty,
    isCompletedHotelInfoHistory,
    isObjectEmpty,
    searchFirstObjectInList,
    isHotelDomestic,
    hideSrpInventoryPage
} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './OtaRatePrograms.scss'

class OtaRatePrograms extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const isDomestic = isHotelDomestic(hotelInfo)

        const isScandanavian = getSessionItem(SessionConst.IS_SCANDANAVIAN) === FormConst.VALUE_YES
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)
        const hideSrpInventory = hideSrpInventoryPage(hotelInfoCompletedHistory, this.props.checklist)

        if (!hotelCode || isObjectEmpty(hotelInfo)) {
            // Go home
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            isDomestic: isDomestic,
            isScandanavian: isScandanavian,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            isEditAda: false,
            roomTypeCodes: [],
            missingRoomTypes: [],
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            hideSrpInventory: hideSrpInventory
        }
    }

    validationSchema = Yup.object().shape({
        adaThreshold: Yup.number()
            .min(0, FormConst.VALIDATION_ERROR_MINIMUM_VALUE_ZERO)
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER),
        adaThresholdOther: Yup.number()
            .min(4, 'Minimum value is 4')
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER),
        financialInformation: Yup.object().when('isFinancialInfoRequired', {
            is: true,
            then: Yup.object().required(FormConst.VALIDATION_ERROR_REQUIRED)
                .shape({
                    managementCompanyName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    withHoldingName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    taxIdNumber: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                        .test('Must be a number and should be 9 digits in length', 'Invalid id', val => {
                            if(this.state.isDomestic) {
                                return new RegExp(FormConst.EXPEDIA_TAX_ID_REGEX_US).test(val)
                            } else {
                                return new RegExp(FormConst.EXPEDIA_TAX_ID_REGEX_NON_US).test(val)
                            }
                        }),
                    paymentMethodType: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
                    taxStatusType: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
                })
        })
    })

    initialValues = {
        adaThreshold: FormConst.ADA_THRESHOLD_DEFAULT,
        isFinancialInfoRequired: false,
        financialInformation: {
            managementCompanyName: '',
            withHoldingName: '',
            taxIdNumber: '',
            paymentMethodType: '',
            taxStatusType: ''
        }
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let otaRatePrograms = this.state.hotelInfoCompletedHistory.newEntity?.otaRatePrograms;

            if (otaRatePrograms) {
                await this.buildFormValues(otaRatePrograms);
            } else {
                this.setState({
                     isLoading: false,
                     showErrorModal: true,
                     errorMessage: FormConst.MODAL_READ_ACTION_ERROR_HISTORY_TEXT
                })
            }
        } else {
            await OtaRateProgramsService.getOtaRatePrograms({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    await this.buildFormValues(response);
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: FormConst.MODAL_READ_ACTION_ERROR_TEXT
                    })
                })
        }
    }

    async buildFormValues(otaRateProgramsObject) {
        // Calculate selected rate programs
        let otaRatePrograms = []
        let isFinancialInfoRequired = false
        let isFinancialInfoFound = false

        let financialInformation = {
            ...this.initialValues.financialInformation
        }

        let isChecklistStatusComplete = false
        const checklistEntry = searchFirstObjectInList('code', 'OTA_RATE_PROGRAMS', this.props.checklist)
        if (checklistEntry?.processedFlag === FormConst.CHECKLIST_STATUS_COMPLETED) {
            isChecklistStatusComplete = true
        }

        if (isArrayNotEmpty(otaRateProgramsObject.otaRatePrograms)) {
            let otaRateProgramsInResponse = otaRateProgramsObject.otaRatePrograms
            if (this.state.isScandanavian) {
                otaRateProgramsInResponse = otaRateProgramsInResponse.filter(program => program.programCode === FormConst.OTA_RATE_PROGRAM_CODE_EXPEDIA)
            }

            otaRateProgramsInResponse.forEach(program => {
                // If the service response has programs then
                // look for the participating flag to decide which ones are selected

                // If it has no name, it's bad data, skip it
                if (!program.programName) {
                    return;
                }

                // If the checklist entry status is complete then it means this page was already saved
                // Just use the participating flag from response
                // Otherwise, set isParticipating to true - select all programs by default
                const isParticipating = isChecklistStatusComplete
                    ? program.participating : true
                otaRatePrograms.push({
                    code: program.programCode,
                    name: program.programName,
                    participating: isParticipating
                })
                // Financial information is required as soon as any program is participating.
                // The same information is saved against every participating program, so read it
                // from the first participating program that has it.
                if (isParticipating) {
                    isFinancialInfoRequired = true
                    if (program.financialInformation && !isFinancialInfoFound) {
                        isFinancialInfoFound = true
                        financialInformation = {
                            managementCompanyName: program.financialInformation.companyName || '',
                            withHoldingName: program.financialInformation.withHoldingName || '',
                            taxIdNumber: program.financialInformation.taxId || '',
                            paymentMethodType: program.financialInformation.paymentMethod || '',
                            taxStatusType: program.financialInformation.taxStatus || ''
                        }
                    }
                }
            })
        }
        this.setState({
            isLoading: false,
            initialValues: {
                ...this.state.initialValues,
                otaRatePrograms: otaRatePrograms,
                isFinancialInfoRequired: isFinancialInfoRequired,
                financialInformation: financialInformation,
                // Thresholds 1, 2 and 3 are saved in adaThreshold
                // These are the 3 options available in the radio buttons provided
                // Any higher value needs to be input manually
                // The value for the option with higher threshold is 0
                //  so as to make it different from other options
                adaThreshold: otaRateProgramsObject.adaThreshold <= 0
                    ? '1'
                    : otaRateProgramsObject.adaThreshold < 4 ? otaRateProgramsObject.adaThreshold.toString() : '0',
                // Value from the text box for threshold > 3
                adaThresholdOther: otaRateProgramsObject.adaThreshold > 3 ? otaRateProgramsObject.adaThreshold : 4
            },
            roomTypeCodes: isArrayNotEmpty(otaRateProgramsObject.roomTypes)
                ? otaRateProgramsObject.roomTypes.map(roomType => roomType.code)
                : [],
            missingRoomTypes: isArrayNotEmpty(otaRateProgramsObject.missingRoomTypes)
                ? otaRateProgramsObject.missingRoomTypes.map(roomType => roomType.code)
                : []
        })
    }

    onEditAda = () => {
        this.setState({
            isEditAda: true
        })
    }

    onSaveAda = () => {
        this.setState({
            isEditAda: false
        })
    }

    handleSubmit = (data) => {
        let putData = {
            otaRatePrograms: data.otaRatePrograms.map(program => {
                return {
                    participating: program.participating,
                    programCode: program.code,
                    programName: program.programName,
                    // The same financial information is saved against every participating program
                    financialInformation: data.isFinancialInfoRequired && program.participating ? {
                        companyName: data.financialInformation.managementCompanyName,
                        withHoldingName: data.financialInformation.withHoldingName,
                        taxId: data.financialInformation.taxIdNumber,
                        paymentMethod: data.financialInformation.paymentMethodType,
                        taxStatus: data.financialInformation.taxStatusType
                    } : undefined,
                    roomTypes: this.state.roomTypeCodes.map(roomTypeCode => {
                        return {
                            code: roomTypeCode
                        }
                    })
                }
            }),
            adaThreshold: data.adaThreshold === '0'
                ? new Number(data.adaThresholdOther)
                : new Number(data.adaThreshold)
        }
        this.props.onPut({ hotelCode: this.state.hotelCode, formData: putData })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription
                })
            } else {
                this.props.history.push(RouteConst.ROUTE_RATEPLANS_PAGE)
            }
        }
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    render() {
        return (
            <div className='ota-rate-programs-page'>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, isSubmitting, resetForm, handleChange, setFieldValue }) => (
                            <Form>
                                <nav aria-label='breadcrumb'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item'><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                        <li className='breadcrumb-item'><NavLink to={RouteConst.ROUTE_RATEPLANS_PAGE}>Rateplans</NavLink></li>
                                        <li className='breadcrumb-item active' aria-current='page'>Third Party Rate Programs</li>
                                    </ol>
                                </nav>
                                <p className='ota-rate-programs-title'>Third Party Rate Programs</p>
                                <p className='helper-text'>
                                    {
                                        this.state.isScandanavian
                                            ? FormConst.OTA_RATE_PROGRAMS_SCANDANAVIAN_HELPER_TEXT
                                            : FormConst.OTA_RATE_PROGRAMS_HELPER_TEXT
                                    }
                                </p>
                                {
                                    this.state.roomTypeCodes.length > 0
                                        ? <div
                                            id='ota-rate-programs-form-fields'
                                            className='ota-rate-programs-form-fields'>
                                            <p className='ota-rate-programs-title'>Room Types</p>
                                            <div className='room-types-fields'>
                                                {
                                                    isArrayNotEmpty(this.state.roomTypeCodes)
                                                    && this.state.roomTypeCodes.map((roomTypeCode, index) => {
                                                        return <TextInput
                                                            key={`roomType-${index}`}
                                                            type='checkbox'
                                                            id={'roomTypeCode-' + index}
                                                            name={`roomTypeCodes.${index}.participating`}
                                                            checked={true}
                                                            suffix={roomTypeCode}
                                                            onChange={handleChange}
                                                            disabled={true} />
                                                    })
                                                }
                                                {
                                                    isArrayNotEmpty(this.state.missingRoomTypes)
                                                    && this.state.missingRoomTypes.map((roomTypeCode, index) => {
                                                        return <TextInput
                                                            key={`missingRoomType-${index}`}
                                                            type='checkbox'
                                                            id={'roomTypeCode-' + index}
                                                            name={`roomTypeCodes.${index}.participating`}
                                                            checked={false}
                                                            suffix={roomTypeCode}
                                                            onChange={handleChange}
                                                            disabled={true} />
                                                    })
                                                }
                                            </div>
                                            <div className='program-fields'>
                                                <p className='ota-rate-programs-title'>Program Names</p>
                                                {
                                                    isArrayNotEmpty(values.otaRatePrograms) ?
                                                        <>
                                                            {
                                                                values.otaRatePrograms.map((rateProgram, index) => {
                                                                    return <TextInput
                                                                        key={`rateProgram-${index}`}
                                                                        type='checkbox'
                                                                        id={'program-' + index}
                                                                        name={`otaRatePrograms.${index}.participating`}
                                                                        checked={rateProgram.participating}
                                                                        suffix={rateProgram.name}
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                            // Financial information is required as soon as any program is
                                                                            // participating. handleChange has not flushed yet, so work out
                                                                            // the next state of the list here.
                                                                            const isFinancialInfoRequired = values.otaRatePrograms
                                                                                .some((program, programIndex) => programIndex === index
                                                                                    ? !program.participating : program.participating)
                                                                            // What has been entered is kept in the form while the section is
                                                                            // hidden so that reselecting a program does not lose it. Saving with
                                                                            // no program selected is what discards the financial information,
                                                                            // it is then entered again on the next visit.
                                                                            setFieldValue('isFinancialInfoRequired', isFinancialInfoRequired)
                                                                        }} />
                                                                })
                                                            }
                                                        </>
                                                        : <p className='helper-text'>No OTA Rate Programs found.</p>
                                                }
                                            </div>
                                            <div className='alert alert-info' role='alert'>
                                                <FaInfoCircle className='mr-2 align-middle' />
                                                {FormConst.OTA_RATE_PROGRAMS_FINANCIAL_INFO_BANNER_TEXT}
                                            </div>
                                            <div className='expedia-financial-info-fields'>
                                                {
                                                    values.isFinancialInfoRequired &&
                                                    <>
                                                        <p className='ota-rate-programs-title'>Financial Information (Required)</p>
                                                        <p className='helper-text'>{FormConst.OTA_RATE_PROGRAMS_FINANCIAL_INFO_HELPER_TEXT}</p>
                                                        <TextInput
                                                            type='text'
                                                            id='expedia-financial-info-owner'
                                                            label='Owner / Management Co. Name:'
                                                            name='financialInformation.managementCompanyName'
                                                            isrequired='true' />
                                                        <TextInput
                                                            type='text'
                                                            id='expedia-financial-info-withholding'
                                                            label='Withholding Name:'
                                                            name='financialInformation.withHoldingName'
                                                            isrequired='true' />
                                                        <TextInput
                                                            type='text'
                                                            id='expedia-financial-info-taxId'
                                                            label='Tax ID / Employer Identification Number:'
                                                            suffix={(this.state.isDomestic)  ? FormConst.EXPEDIA_TAX_ID_REGEX_US_SUFIX : FormConst.EXPEDIA_TAX_ID_REGEX_NON_US_SUFIX}
                                                            name='financialInformation.taxIdNumber'
                                                            isrequired='true' />
                                                        <SelectInput
                                                            id='expedia-financial-info-payment'
                                                            label='Method of payment'
                                                            options={FormConst.FINANCIAL_INFO_PAYMENT_TYPES}
                                                            suffix='(for hotel to collect commmissions)'
                                                            name='financialInformation.paymentMethodType'
                                                            isrequired='true' />
                                                        <SelectInput
                                                            id='expedia-financial-info-tax-status'
                                                            label='Tax Status'
                                                            options={FormConst.FINANCIAL_INFO_TAX_STATUS_TYPE}
                                                            name='financialInformation.taxStatusType'
                                                            isrequired='true' />
                                                    </>
                                                }
                                            </div>

                                            <div className='ada-threshold-info-fields'>
                                                <p className='ota-rate-programs-title'>Thresholds</p>
                                                <div>
                                                    <p className='helper-text mt-0 mb-0'>Please note, the number of room types available
                                                    to your online partners is controlled by predefined thresholds.</p>
                                                    {
                                                        this.state.isEditAda ?
                                                            <div className='ada-threshold-edit'>
                                                                <RadioInput
                                                                    id='ada-threshold'
                                                                    name='adaThreshold'
                                                                    label='Select a new threshold value for ADA:'
                                                                    checked={values.adaThreshold}
                                                                    options={[
                                                                        { label: '1 - I must have one or more rooms available of a given room type in order to sell on the OTAs.', value: '1' },
                                                                        { label: '2 - I must have two or more rooms available of a given room type in order to sell on the OTAs.', value: '2' },
                                                                        { label: '3 - I must have three or more rooms available of a given room type in order to sell on the OTAs.', value: '3' },
                                                                        {
                                                                            label: <TextInput
                                                                                name='adaThresholdOther'
                                                                                type='number'
                                                                                min='4'
                                                                                label='More than 3. Please specify: '
                                                                                disabled={values.adaThreshold !== '0'} />,
                                                                            value: '0'
                                                                        }
                                                                    ]}
                                                                    isrequired='true' />
                                                            </div>
                                                            :
                                                            <>
                                                                For <b>ADA</b> rooms it is {values.adaThreshold === '0' ? values.adaThresholdOther : values.adaThreshold}.
                                                                If you wish to change the <b>ADA</b> threshold click <Button role='link' name='here' onClick={this.onEditAda} /> for your options.
                                                            </>
                                                    }
                                                    <br />
                                                    For <b>non-ADA</b> rooms it is {FormConst.NON_ADA_THRESHOLD_DEFAULT}. If you wish to change the <b>non-ADA</b> threshold, contact your {FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}.
                                                </div>
                                            </div>
                                        </div>
                                        : <div id='ota-rate-programs-form-fields' className='ota-rate-programs-form-fields'>
                                            <h6 className='helper-text error'>
                                                {
                                                    this.state.isScandanavian
                                                        ? FormConst.OTA_RATE_PROGRAMS_NO_ROOM_TYPES_SCANDANAVIA_HELPER_TEXT
                                                        : FormConst.OTA_RATE_PROGRAMS_NO_ROOM_TYPES_HELPER_TEXT
                                                }
                                            </h6>
                                        </div>
                                }
                                <FormFooter
                                    form={{
                                        previous: this.state.hideSrpInventory ? { title: 'Box Inventory', route: RouteConst.ROUTE_BOX_INVENTORY_PAGE } : { title: 'SRP Inventory', route: RouteConst.ROUTE_SRP_INVENTORY_PAGE },
                                        next: { title: 'Other Rate Plans', route: RouteConst.ROUTE_OTHER_RATEPLANS_PAGE }
                                    }}
                                    isSubmit
                                    submitName={FormConst.SAVE_BUTTON_TEXT}
                                    resetName={FormConst.RESET_BUTTON_TEXT}
                                    onReset={this.handleClearForm}
                                    submitDisabled={isSubmitting} />
                                <FormModal
                                    id='ota-rate-programs-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='ota-rate-programs-page-reset-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_RESET_ACTION_TITLE}
                                    body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                    proceed={() => {
                                        this.resetFormData(resetForm)
                                    }}
                                    cancel={() => { this.setState({ showResetModal: false }) }}
                                    show={this.state.showResetModal} />
                                <FormModal
                                    id='ota-rate-programs-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        otaRateProgramsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_OTA_RATE_PROGRAMS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_OTA_RATE_PROGRAMS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(OtaRatePrograms, SideNavEntryMapping.RATE_PLANS))
